import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isKnCode: ValidatorFn = Validators.pattern(`^[0-9]{8}$`);

export const knCodeValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp = '^[0-9]{8}$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { knCode: true };
};
